import { t, TOptions } from 'i18next';

export const getPageTitle = (pageKey: string, options?: TOptions): string =>
  `${t(`pages.${pageKey}.pageTitle`, options)}`;
